module.exports = __webpack_public_path__ + "img/i19.2b7547c7.svg";